import { useState } from "react";
import { signOut } from "firebase/auth";
import { auth } from "./firebase";
import Form from "./Form";
import UserList from "./UserList";
import "./Dashboard.css";

export default function Dashboard({ user, setUser }) {
  const [activeTab, setActiveTab] = useState("add");
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleLogout = async () => {
    await signOut(auth);
    setUser(null);
  };

  const initials = user.email ? user.email[0].toUpperCase() : "A";

  return (
    <div className={`dash-root ${sidebarOpen ? "sidebar-open" : "sidebar-closed"}`}>

      {/* ── NAVBAR ── */}
      <header className="dash-navbar">
        <div className="dash-navbar-left">
          <button className="dash-hamburger" onClick={() => setSidebarOpen((v) => !v)}>
            <span /><span /><span />
          </button>
          <div className="dash-brand">
            {/* <span className="dash-brand-icon">🏦</span> */}
            <span className="dash-brand-name"> <span>Admin</span></span>
          </div>
        </div>

        <div className="dash-navbar-right">
          <div className="dash-user-pill">
            <div className="dash-user-avatar">{initials}</div>
            <div className="dash-user-info">
              <span className="dash-user-email">{user.email}</span>
              <span className="dash-user-role">Administrator</span>
            </div>
          </div>
          <button className="dash-logout-btn" onClick={handleLogout} title="Sign Out">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
              <polyline points="16 17 21 12 16 7"/>
              <line x1="21" y1="12" x2="9" y2="12"/>
            </svg>
            <span>Sign Out</span>
          </button>
        </div>
      </header>

      {/* ── SIDEBAR ── */}
      <aside className="dash-sidebar">
        <div className="dash-sidebar-inner">
          <p className="dash-sidebar-label">MENU</p>

          <nav className="dash-nav">
            <button
              className={`dash-nav-item ${activeTab === "add" ? "active" : ""}`}
              onClick={() => { setActiveTab("add"); if (window.innerWidth < 768) setSidebarOpen(false); }}
            >
              <span className="dash-nav-icon">
                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/>
                </svg>
              </span>
              <span className="dash-nav-label">Add Data</span>
              {activeTab === "add" && <span className="dash-nav-dot" />}
            </button>

            <button
              className={`dash-nav-item ${activeTab === "list" ? "active" : ""}`}
              onClick={() => { setActiveTab("list"); if (window.innerWidth < 768) setSidebarOpen(false); }}
            >
              <span className="dash-nav-icon">
                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/>
                  <line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/>
                </svg>
              </span>
              <span className="dash-nav-label">View Data</span>
              {activeTab === "list" && <span className="dash-nav-dot" />}
            </button>
          </nav>

          <div className="dash-sidebar-footer">
            <button className="dash-sidebar-logout" onClick={handleLogout}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                <polyline points="16 17 21 12 16 7"/>
                <line x1="21" y1="12" x2="9" y2="12"/>
              </svg>
              Sign Out
            </button>
          </div>
        </div>
      </aside>

      {/* Mobile overlay */}
      {sidebarOpen && (
        <div className="dash-overlay" onClick={() => setSidebarOpen(false)} />
      )}

      {/* ── MAIN CONTENT ── */}
      <main className="dash-main">
        {activeTab === "add" && (
          <FormWrapper user={user} setUser={setUser} />
        )}
        {activeTab === "list" && (
          <UserList user={user} />
        )}
      </main>

    </div>
  );
}

// Wrap Form so it doesn't show its own outer wrapper/card chrome
function FormWrapper({ user, setUser }) {
  return (
    <div className="dash-form-wrapper">
      <Form user={user} setUser={setUser} embedded />
    </div>
  );
}